module.exports = __webpack_public_path__ + "img/footer2.ba1facd3.png";